<template>
  <div>
    <div class="bg-white shadow p-2 mb-3">

      <div class="row">
        <div class="col">
          <v-select
            multiple
            v-model="filter.itemId"
            :options="listItem"
            :reduce="item => item.ID"
            label="Name"
            placeholder="Pilih barang" />
        </div>
        <div class="col">
          <v-select
            v-model="filter.supplierId"
            :options="listSupplier"
            :reduce="item => item.ID"
            label="Name"
            placeholder="Pilih Supplier" />
        </div>
      </div>

      <div class="row mt-2">
        <div class="col">
          <b-form-datepicker v-model="filter.startEntryDate" locale="id" size="sm" />
        </div>
        <div class="col">
          <b-form-datepicker v-model="filter.endEntryDate" locale="id" size="sm" />
        </div>
      </div>

      <div class="row mt-2">
        <div class="col">
          <button class="btn btn-sm btn-primary btn-icon-split" @click="onRefresh" :disabled="isLoading">
            <span class="icon"><i class="fas fa-search" /></span>
            <span class="text">Cari <b-spinner small v-show="isLoading" /></span>
          </button>
        </div>

        <div class="col text-right">
          <button class="btn btn-sm btn-info btn-icon-split text-dark mr-2" @click="onRefresh" :disabled="isLoading">
            <span class="icon"><i class="fas fa-print" /></span>
            <span class="text">Cetak <b-spinner small v-show="isLoading" /></span>
          </button>

          <button class="btn btn-sm btn-success btn-icon-split text-dark" @click="onRefresh" :disabled="isLoading">
            <span class="icon"><i class="fas fa-file-excel" /></span>
            <span class="text">Export Excel <b-spinner small v-show="isLoading" /></span>
          </button>
        </div>
      </div>

    </div>


    <AppTable
      :apiUrl="apiUrl"
      :fields="tableFields"
      :search="search"
      @onSelectItem="selectedItem = $event" />
  </div>
</template>

<script>
import AppToolbox from '@/components/app/AppToolbox.vue'
import AppTable from '@/components/app/AppTable.vue'

export default {
  components: { AppToolbox, AppTable },
  mounted() {
    this.loadOptionData()
  },
  data() {
    return {
      apiUrl: '/logistic-purchase-report',
      tableFields: [
        { key: 'index', label: 'No.' },
        { key: 'EntryDate', label: 'Tanggal', formatter: value => this.$helper.formatDateTime(value) },
        { key: 'ItemName', label: 'Nama Barang' },
        { key: 'Supplier', label: 'Supplier' },
        { key: 'Quantity', label: 'Quantity' },
        { key: 'Price', label: 'Harga', formatter: value => this.$helper.formatRupiah(value) },
        { key: 'InvoiceID', label: 'No. Faktur' },
      ],
      selectedItem: null,
      search: '',
      listItem: [],
      listSupplier: [],
      filter: {
        itemId: null,
        supplierId: null,
        startEntryDate: (new Date()).toISOString().slice(0,10),
        endEntryDate: (new Date()).toISOString().slice(0,10)
      }
    }
  },
  computed: {
    isLoading () {
      return this.$store.state.isLoading
    }
  },
  methods: {
    onRefresh () {
      this.$emit('refreshTable')
    },
    loadOptionData () {
      this.$axios.all([
        this.$axios.get('/logistic-item'),
        this.$axios.get('/logistic-supplier')
      ]).then(this.$axios.spread((...res) => {
        this.listItem = res[0].data
        this.listSupplier = res[1].data
      }))
    }
  }
}
</script>
